export default [
    {
        path: 'denial-management',
        name: 'denial-dashboard-page',
        component: () => import('../views/DenialManagement'),
    },
];
